import { validateInputs } from 'shared/lib';
import { SignUpErrors } from 'shared/consts/sign-up.error';

export const validateSignUpForm = (
  fullName: string,
  email: string,
  phone: string,
  password: string,
  confirmPassword: string,
  isTermsAccepted: boolean,
  isDataConsentAccepted: boolean
) => {
  // Валидация ФИО
  if (!validateInputs.validateFullName(fullName)) {
    return SignUpErrors.INCORRECT_FULL_NAME;
  }

  // Валидация email
  else if (!validateInputs.validateMail(email)) {
    return SignUpErrors.INCORRECT_EMAIL;
  }

  // Валидация телефона
  else if (!validateInputs.validatePhone(phone)) {
    return SignUpErrors.INCORRECT_PHONE;
  }

  // Валидация пароля
  else if (!validateInputs.validatePassword(password)) {
    return SignUpErrors.INCORRECT_PASSWORD;
  }

  // Валидация подтверждения пароля
  else if (!validateInputs.validateConfirmPassword(password, confirmPassword)) {
    return SignUpErrors.PASSWORDS_NOT_MATCH;
  } else if (!isTermsAccepted || !isDataConsentAccepted) {
    return SignUpErrors.CONSENT_NOT_ACCEPTED;
  } else {
    return SignUpErrors.NO_ERRORS;
  }
};
